var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",staticStyle:{"min-height":"100vh","height":"auto","background-size":"cover","padding-bottom":"15rem","background-attachment":"fixed"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }